/**
  © BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
  Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/
if (!customElements.get('blocky-video')) {
  customElements.define('blocky-video',
    class BlockyVideo extends HTMLElement {
      constructor() {
        super()
        const video = this.querySelector("video")
        if (this.classList.contains("blocky-video-manual")) {
          video.addEventListener("click", (e) => this.onClick())
          const button = this.querySelector(".blocky-video-play-button")
          button.addEventListener("click", (e) => this.onClick())
        } else {
          video.addEventListener("pause", (event) => {
              if (event.target.paused) event.target.play()
          })
          video.addEventListener("canplay", (event) => {
              if (event.target.paused) event.target.play()
          })
        }
      }

      onClick() {
        const video = this.querySelector("video")
        const button = this.querySelector(".blocky-video-play-button")
        if (video.paused == true) {
          video.play()      
          button.classList.add("blocky-hidden")
        } else {
          video.pause()
          button.classList.remove("blocky-hidden")
        }
      }       
    }
  )
}
